// Se existir auth, coloca em todos os XHML HTTP Request
let originalOpen = XMLHttpRequest.prototype.open

XMLHttpRequest.prototype.open = function () {
  originalOpen.apply(this, arguments)
  // Verifica AUTH
  let auth = localStorage.getItem('auth')
  auth = auth ? JSON.parse(auth) : {}
  if (auth.token) this.setRequestHeader('Authorization', `Bearer ${auth.token}`)
}
